// Generated from fixed build58. Run scripts/generate-badge-reference.cjs.
const previewBadge = (
  key,
  name,
  category,
  description,
  targetValue,
  tier,
  hidden = false,
  iconKey = category.toLowerCase(),
) => ({
  key,
  name,
  category,
  iconKey,
  description,
  unlockHint: description,
  tier,
  hidden,
  currentValue: 0,
  targetValue,
  progressPercent: 0,
  unlockedAt: null,
  featured: false,
});
const previewCategories = [
  {
    key: 'GOALS',
    name: '목표 달성',
    description: '스스로 정한 음악 목표',
    badges: [
      previewBadge(
        'goal_first',
        '첫 목표',
        'GOALS',
        '주간 또는 월간 음악 목표를 처음 모두 달성해요.',
        1,
        1,
        false,
        'target',
      ),
      previewBadge(
        'goal_week_streak_4',
        '네 번의 약속',
        'GOALS',
        '서로 다른 4주의 음악 목표를 모두 달성해요.',
        4,
        2,
        false,
        'calendar-check',
      ),
      previewBadge(
        'goal_week_streak_12',
        '계절의 리듬',
        'GOALS',
        '서로 다른 12주의 음악 목표를 모두 달성해요.',
        12,
        3,
        false,
        'calendar-check',
      ),
      previewBadge(
        'goal_three_months',
        '세 달의 리듬',
        'GOALS',
        '서로 다른 세 달의 음악 목표를 모두 달성해요.',
        3,
        2,
        false,
        'target',
      ),
      previewBadge(
        'goal_six_months',
        '반년의 약속',
        'GOALS',
        '서로 다른 6개월의 음악 목표를 모두 달성해요.',
        6,
        3,
        false,
        'trophy',
      ),
    ],
  },
  {
    key: 'RECORDING',
    name: '기록',
    description: '듣고 남긴 감상 기록',
    badges: [
      previewBadge(
        'ratings_10',
        '첫 열 장',
        'RECORDING',
        '서로 다른 앨범 10장을 평가해요.',
        10,
        1,
        false,
        'disc',
      ),
      previewBadge(
        'ratings_50',
        '쉰 장의 기억',
        'RECORDING',
        '서로 다른 앨범 50장을 평가해요.',
        50,
        2,
        false,
        'library',
      ),
      previewBadge(
        'ratings_100',
        '백 장의 귀',
        'RECORDING',
        '서로 다른 앨범 100장을 평가해요.',
        100,
        3,
        false,
        'award',
      ),
      previewBadge(
        'reviews_first',
        '첫 감상',
        'RECORDING',
        '첫 번째 본문 리뷰를 남겨요.',
        1,
        1,
        false,
        'book-open',
      ),
      previewBadge(
        'reviews_25',
        '리뷰 노트',
        'RECORDING',
        '서로 다른 앨범 25장에 리뷰를 남겨요.',
        25,
        2,
        false,
        'book-open',
      ),
      previewBadge(
        'reviews_50',
        '오십 편의 기록',
        'RECORDING',
        '서로 다른 앨범 50장에 리뷰를 남겨요.',
        50,
        3,
        false,
        'book-open',
      ),
      previewBadge(
        'track_ratings_25',
        '곡을 듣는 귀',
        'RECORDING',
        '서로 다른 곡 25개를 평가해요.',
        25,
        2,
        false,
        'music-2',
      ),
    ],
  },
  {
    key: 'EXPLORATION',
    name: '탐색',
    description: '시대와 장르를 넘는 발견',
    badges: [
      previewBadge(
        'decades_5',
        '시간 여행자',
        'EXPLORATION',
        '5개 발매 연대의 앨범을 평가해요.',
        5,
        1,
      ),
      previewBadge(
        'decades_8',
        '세기의 산책자',
        'EXPLORATION',
        '8개 발매 연대의 앨범을 평가해요.',
        8,
        3,
        false,
        'map',
      ),
      previewBadge(
        'genres_10',
        '장르 탐험가',
        'EXPLORATION',
        '10개 장르의 앨범을 평가해요.',
        10,
        2,
      ),
      previewBadge(
        'genres_20',
        '경계 없는 귀',
        'EXPLORATION',
        '20개 장르의 앨범을 평가해요.',
        20,
        3,
        false,
        'compass',
      ),
    ],
  },
  {
    key: 'DISCOVERY',
    name: '발견',
    description: '앱 곳곳에서 만난 음악과 회원',
    badges: [
      previewBadge(
        'members_explored_10',
        '취향의 이웃',
        'DISCOVERY',
        '서로 다른 회원 10명의 음악 기록을 살펴봐요.',
        10,
        1,
        false,
        'users',
      ),
      previewBadge(
        'members_explored_30',
        '취향의 골목',
        'DISCOVERY',
        '서로 다른 회원 30명의 음악 기록을 살펴봐요.',
        30,
        2,
        false,
        'users',
      ),
      previewBadge(
        'members_explored_100',
        '백 개의 취향 지도',
        'DISCOVERY',
        '서로 다른 회원 100명의 음악 기록을 살펴봐요.',
        100,
        3,
        false,
        'map',
      ),
      previewBadge(
        'saves_10',
        '다시 들을 목록',
        'DISCOVERY',
        '앨범·리뷰·플리를 10개 저장해요.',
        10,
        1,
        false,
        'bookmark',
      ),
      previewBadge(
        'saves_50',
        '나만의 음악 서가',
        'DISCOVERY',
        '앨범·리뷰·플리를 50개 저장해요.',
        50,
        2,
        false,
        'bookmark',
      ),
      previewBadge(
        'discoveries_25',
        '스물다섯 번의 발견',
        'DISCOVERY',
        '서로 다른 음악 콘텐츠 25개를 탐색해요.',
        25,
        1,
        false,
        'search',
      ),
      previewBadge(
        'discoveries_100',
        '백 번의 발견',
        'DISCOVERY',
        '서로 다른 음악 콘텐츠 100개를 탐색해요.',
        100,
        2,
        false,
        'search',
      ),
    ],
  },
  {
    key: 'SHARING',
    name: '공유',
    description: '밖으로 건넨 음악 취향',
    badges: [
      previewBadge(
        'shares_first',
        '첫 번째 건넴',
        'SHARING',
        '음악 기록을 처음 외부에 공유해요.',
        1,
        1,
        false,
        'share-2',
      ),
      previewBadge(
        'shares_3',
        '취향을 건네는 사람',
        'SHARING',
        '서로 다른 음악 기록을 3번 공유해요.',
        3,
        2,
        false,
        'send',
      ),
      previewBadge(
        'shares_20',
        '스무 번의 음악 편지',
        'SHARING',
        '서로 다른 음악 기록을 20번 공유해요.',
        20,
        3,
        false,
        'mail',
      ),
    ],
  },
  {
    key: 'CURATION',
    name: '큐레이션',
    description: '나만의 음악 묶음',
    badges: [
      previewBadge(
        'playlist_5',
        '첫 큐레이션',
        'CURATION',
        '서로 다른 항목 5개 이상인 플리를 만들어요.',
        5,
        1,
      ),
      previewBadge(
        'playlist_20',
        '긴 호흡의 셀렉션',
        'CURATION',
        '서로 다른 항목 20개 이상인 플리를 만들어요.',
        20,
        2,
        false,
        'list-music',
      ),
      previewBadge(
        'curator_3',
        '큐레이터',
        'CURATION',
        '조건을 충족한 공개 플리 3개를 만들어요.',
        3,
        2,
      ),
      previewBadge(
        'curator_10',
        '열 개의 진열장',
        'CURATION',
        '항목 5개 이상인 플리 10개를 만들어요.',
        10,
        3,
        false,
        'list-checks',
      ),
    ],
  },
  {
    key: 'COMMUNITY',
    name: '커뮤니티',
    description: '함께 나눈 음악 이야기',
    badges: [
      previewBadge(
        'community_days_3',
        '대화의 시작',
        'COMMUNITY',
        '서로 다른 3일에 음악 이야기를 남겨요.',
        3,
        1,
      ),
      previewBadge(
        'community_days_30',
        '서른 날의 대화',
        'COMMUNITY',
        '서로 다른 30일에 음악 이야기를 남겨요.',
        30,
        3,
        false,
        'message-circle',
      ),
      previewBadge(
        'following_5',
        '다섯 취향의 연결',
        'COMMUNITY',
        '관심 있는 회원 5명을 팔로우해요.',
        5,
        1,
        false,
        'user-plus',
      ),
      previewBadge(
        'following_20',
        '스무 취향의 연결',
        'COMMUNITY',
        '관심 있는 회원 20명을 팔로우해요.',
        20,
        2,
        false,
        'user-plus',
      ),
      previewBadge(
        'reactions_10',
        '공감받는 기록',
        'COMMUNITY',
        '내 리뷰와 플리가 서로 다른 10명에게 반응을 얻어요.',
        10,
        2,
      ),
    ],
  },
  {
    key: 'STREAK',
    name: '연속 활동',
    description: '꾸준히 이어간 음악 생활',
    badges: [
      previewBadge(
        'streak_3',
        '3일의 리듬',
        'STREAK',
        '의미 있는 음악 활동을 3일 연속 이어가요.',
        3,
        1,
      ),
      previewBadge(
        'streak_7',
        '일주일의 리듬',
        'STREAK',
        '의미 있는 음악 활동을 7일 연속 이어가요.',
        7,
        2,
      ),
      previewBadge(
        'active_weeks_4',
        '네 주의 음악 생활',
        'STREAK',
        '한 주에 3일 이상 활동하는 흐름을 4주 이어가요.',
        4,
        2,
        false,
        'calendar-check',
      ),
      previewBadge(
        'active_weeks_12',
        '한 계절의 음악 생활',
        'STREAK',
        '한 주에 3일 이상 활동하는 흐름을 12주 이어가요.',
        12,
        3,
        false,
        'calendar-range',
      ),
    ],
  },
  {
    key: 'MASTERY',
    name: '종합 업적',
    description: '앱 전반에 걸쳐 쌓은 음악 생활',
    badges: [
      previewBadge(
        'mastery_1',
        '취향의 설계자',
        'MASTERY',
        '포스트팝의 여러 활동을 고르게 시작해요.',
        1,
        1,
        false,
        'sparkles',
      ),
      previewBadge(
        'mastery_2',
        '음악 생활의 장인',
        'MASTERY',
        '포스트팝의 여러 활동을 중간 단계까지 고르게 이어가요.',
        2,
        2,
        false,
        'gem',
      ),
      previewBadge(
        'mastery_3',
        '포스트팝 마스터',
        'MASTERY',
        '포스트팝의 여러 활동에서 최고 단계에 도달해요.',
        3,
        3,
        false,
        'crown',
      ),
    ],
  },
];
export const badgePreview = {
  earnedCount: 0,
  totalCount: previewCategories.reduce((total, category) => total + category.badges.length, 0),
  profileMarkType: 'NONE',
  featuredBadge: null,
  categories: previewCategories,
  preview: true,
};
const sponsorshipPreviewStages = [
  {
    key: 'support_stage_1',
    name: '첫 울림',
    description: '첫 검증 후원으로 시작한 기록',
    paidMonths: 1,
    level: 1,
    earned: false,
  },
  {
    key: 'support_stage_3',
    name: '이어지는 리듬',
    description: '후원 혜택과 함께한 누적 3개월',
    paidMonths: 3,
    level: 2,
    earned: false,
  },
  {
    key: 'support_stage_6',
    name: '한 장의 레코드',
    description: '후원 혜택과 함께한 누적 6개월',
    paidMonths: 6,
    level: 3,
    earned: false,
  },
  {
    key: 'support_stage_12',
    name: '한 해의 동행',
    description: '후원 혜택과 함께한 누적 12개월',
    paidMonths: 12,
    level: 4,
    earned: false,
  },
  {
    key: 'support_stage_24',
    name: '포스트팝 아카이브',
    description: '후원 혜택과 함께한 누적 24개월',
    paidMonths: 24,
    level: 5,
    earned: false,
  },
];
export const sponsorshipMarkPreview = {
  isSupporter: false,
  isActive: false,
  partnerActive: false,
  currentActiveMonths: 0,
  currentPaidMonths: 0,
  currentStage: null,
  stages: sponsorshipPreviewStages,
};
badgePreview.sponsorshipMark = sponsorshipMarkPreview;
